// Class merge helper for the UI primitives (app/components/ui). tailwind-merge
// deduplicates conflicting Tailwind classes so a caller's className wins over a
// primitive's default — e.g. <Button className="px-8"> extends the default
// padding instead of both landing in the markup unpredictably. The extended
// config registers the design system's radius scale (rounded-button/card/pill,
// see globals.css @theme) as one conflict group, so "rounded-full" (pills)
// correctly overrides a "rounded-button" default and vice versa.
import { extendTailwindMerge } from "tailwind-merge";

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      rounded: [{ rounded: ["button", "card", "pill"] }],
    },
  },
});

export function cn(...classes: Array<string | false | null | undefined>) {
  return twMerge(classes.filter(Boolean).join(" "));
}
